module.exports = __webpack_public_path__ + "static/use-case-3-content-4-df1078be4cd83585cbaba76923fa867f.png";